import * as d3 from "d3";


import {
    // axisTextDim1,
    colonAnnotation, contextMenu,
    DEFAULT_AXIS_FONT_SIZE,
    DEFAULT_AXIS_LABEL_FONT_SIZE,
    createTooltip, generateDownloadData,
    inrFormatter,
    numberFormat,
    responsivefy,
    // XaxisAttribute
} from '../functions'

export default function (chart, divId, vizName, resData,filterParam) {
    const defaultSize = true
    const defaultChartLayout = {
        width: 1000,
        height: 500,
        margin: { top: 30, right: 280, bottom: 100, left: 120 }
    }
    const chartWidth = defaultSize ? defaultChartLayout.width : chart.width
    const chartHeight = defaultSize ? defaultChartLayout.height : chart.height
    const chartMargin = defaultSize ? defaultChartLayout.margin : chart.margin

    const axisTickFontPx = defaultSize ? DEFAULT_AXIS_FONT_SIZE : chart.axisFontSize
    var axisfontsize = axisTickFontPx + 'px'
    var axislabelfontsize = (defaultSize ? DEFAULT_AXIS_LABEL_FONT_SIZE : chart.axisLabelFontSize) + 'px'
    var axislabelfontcolor = chart.axisLabelFontColor
    var axisfontcolor = chart.axisFontColor
    //var tempVar = chart.tempVar
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    var svg = d3.select(divId).select("svg").remove();
    svg = d3.select(divId).append('svg')
        .attr('width', chartWidth + chartMargin.left + chartMargin.right)
        .attr('height', chartHeight + chartMargin.top + 2 * chartMargin.bottom)
        .call(responsivefy)
        .append('g')
        .attr('transform', 'translate(' + chartMargin.left + ',' + chartMargin.top + ')')

    var x1Scale = d3.scaleLinear().range([0, chartWidth])
    var y1Scale = d3.scaleBand()
        .range([chartHeight, 0])
        .paddingInner(0.25)
        .paddingOuter(0.15);
    var x1AxisLabel = d3.axisBottom(x1Scale).ticks(8).tickFormat(numberFormat)
    // var y1AxisLabel = d3.axisLeft(y1Scale)

    function truncate(text, maxLength) {
        return text.length > maxLength
            ? text.slice(0, maxLength) + '…'
            : text;
    }


    // axios.post(url, filterParam).then(res => {
        let data = resData

        data.sort((a, b) => {
            return a.metric1 - b.metric1
        })

        x1Scale.domain([0, d3.max(data, (d) => {
            return d.metric1
        })])
        y1Scale.domain(data.map((d) => {
            return d.dim1_name
        })).paddingInner(0.3)

        svg.append('g')
            .attr('class', 'x axis')
            .attr('transform', 'translate(0,' + chartHeight + ')')
            .call(x1AxisLabel)
            .selectAll('text')
            .style('font-size', axisfontsize)
            .style('fill', axisfontcolor)

    svg.append('g')
        .attr('class', 'y axis')
        .call(
            d3.axisLeft(y1Scale)
                .tickSize(0)
                .tickPadding(10)
        )
        .selectAll('text')
        .style('font-size', axisfontsize)
        .style('fill', axisfontcolor)


    svg.append('text')
            .attr('x', (chartWidth / 2))
            .attr('y', chartHeight + chartMargin.bottom - 30)
            .style('fill', axisfontcolor)
            .text(chart.x1AxisDisplayName)
            .style('font-size', axislabelfontsize)
            .attr('text-anchor', 'middle')


    svg.append('text')
            .attr('x', (chartWidth / 2))
            .attr('y', 0 - (chartMargin.top / 2))
            .attr('text-anchor', 'middle')
            .style('fill', axisfontcolor)
            .text(chart.x2AxisDisplayName)
            .style('font-size', axislabelfontsize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chartMargin.left + 5)
            .attr('x', 0 - (chartHeight / 2))
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', axislabelfontcolor)
            .text(chart.y1AxisDisplayName)
            .style('font-size', axislabelfontsize)


    svg.select('.y.axis')
        .selectAll('text')
        .text(d => truncate(d, 14))
        .append('title')   // tooltip
        .text(d => d);


    /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element
         var y1tip = tooltip_class()

         y1tip.attr('class', 'd3-tip'+divId.id).html((d) =>{
                return d.dim1_name+ colonAnnotation+ numberFormat(d.metric1)
        })

        svg.call(y1tip);*/

        const tooltip = createTooltip(divId);

        svg.selectAll('.bar')
            .data(data)
            .enter()
            .append('rect')
            .attr('height', y1Scale.bandwidth())
            .attr('y', d => {
                return y1Scale(d.dim1_name)
            })
            .attr('width', d => {
                return x1Scale(d.metric1)
            })
            .style('fill', d => {
                return (d.colorClass == 'top' ? chart.vizSpecific4 : chart.vizSpecific5)
            })
            .on("mouseover", function(event, d) {
                tooltip.onMouseOver(d, this, function(d) {
                    // Tooltip content callback
                    return d.dim1_name + colonAnnotation + inrFormatter(d.metric1)
                });  // Pass the event for positioning
            })
            .on('mousemove', function(event) {
                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
            })
            .on("mouseout", function() {
                // Hide the tooltip on mouse out
                tooltip.onMouseLeave();
            })
            .on('contextmenu', function(event, d) {

                // Prepare clickedData with both axes' info
                const clickedData = {
                    [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]: [d.dim1_name]               // e.g., "metric1"
                };
                console.log("clickedData",clickedData);
                // Generate the menu with current config and filters
                const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

                // Show the context menu
                contextMenu(menuItems).call(this, clickedData);

                // Prevent default context menu
                event.preventDefault();
            });

        svg.selectAll('text.bar')
            .data(data)
            .enter()
            .append("text")
            .attr("class", ".bar")
            .attr("y", (d) => {
                return y1Scale(d.dim1_name) + y1Scale.bandwidth() / 2 + 6
            })
            .attr("x", (d) => {
                return x1Scale(d.metric1)
            })
            .text((d) => {
                return inrFormatter(d.metric1)
            })
            .style("fill", "black")
            .style("font-size", ((defaultSize ? DEFAULT_AXIS_LABEL_FONT_SIZE : chart.axisLabelFontSize) - 5) + "px");
    // })
}